











































import Vue from 'vue';
import { AxiosError, AxiosResponse } from 'axios';

import AccountingAPI from '@/services/AccountingAPI';
import Util from '@/util/Util';

import AccountingOverview from '@/types/AccountingOverview';

import Loader from '@/components/Loader.vue';

export default Vue.extend({
    name: 'Accounting',

    components: {
        Loader
    },

    data() {
        return {
            accountingOverview: new AccountingOverview(),
            error: '',
            status: '',
            isLoading: false
        };
    },

    created() {
        this.loadAccountingOverview();
    },

    methods: {
        loadAccountingOverview(): void {
            const handleResponse = (response: AxiosResponse) => {
                    this.accountingOverview = response.data;
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error = error.response.data.message;
                    }
                };

            this.isLoading = true;
            AccountingAPI
                .get()
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoading = false);
        },

        getRoyaltyReport(): void {
            const handleResponse = (response: AxiosResponse) => {
                    Util.saveFile(response.data, 'Royalty_Report.csv', 'text/csv');
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error = error.response.data.message;
                    }
                };

            this.isLoading = true;
            AccountingAPI
                .getRoyaltyReport()
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoading = false);
        },

        getManagementReport(): void {
            const handleResponse = (response: AxiosResponse) => {
                    Util.saveFile(response.data, 'ManagementFee_Report.csv', 'text/csv');
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error = error.response.data.message;
                    }
                };

            this.isLoading = true;
            AccountingAPI
                .getManagementReport()
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoading = false);
        },
    }
});
